import './saffron/style';
import FormStructure from './saffron/form_structure';

export default FormStructure;